export default __webpack_public_path__ + "90a4a50f49ad5bb1a30b526b237e85a8.svg";